<script setup lang="ts">
import type { Colors, Sizes } from 'types';
import { computed } from 'vue';

export interface TextProps {
  value?: string;
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
  strikethrough?: boolean;
  color?: Colors;
  size?: Sizes;
}

const props = defineProps<TextProps>();

const classes = computed(() => [
  'e-text',
  props.bold && `e-text-bold`,
  props.italic && `e-text-italic`,
  props.underline && `e-text-underline`,
  props.strikethrough && `e-text-strikethrough`,
  props.color && `e-text-color-${props.color}`,
  props.size && `e-text-size-${props.size}`
]);
</script>

<template>
  <p :class="classes">
    <slot>
      {{ value }}
    </slot>
  </p>
</template>
